<template>
  <div class="ccontainer ccontainer-icon" @click="toggle">
    <button class="toolbox-button">
      <div>
        <div class="toolbox-icon">
          <div class="jitsi-icon jitsi-icon-default">
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                v-if="isFullscreen"
                d="M13.5 9a1.5 1.5 0 0 0 1.5 1.5h5.25a.75.75 0 0 0 0-1.5H15V3.75a.75.75 0 0 0-1.5 0V9ZM10.5 15A1.5 1.5 0 0 0 9 13.5H3.75a.75.75 0 0 0 0 1.5H9v5.25a.75.75 0 0 0 1.5 0V15ZM10.5 9A1.5 1.5 0 0 1 9 10.5H3.75a.75.75 0 0 1 0-1.5H9V3.75a.75.75 0 0 1 1.5 0V9ZM15 13.5a1.5 1.5 0 0 0-1.5 1.5v5.25a.75.75 0 0 0 1.5 0V15h5.25a.75.75 0 0 0 0-1.5H15Z"
              ></path>
              <path
                v-else
                d="M3 1.5A1.5 1.5 0 0 0 1.5 3v5.25a.75.75 0 0 0 1.5 0V3h5.25a.75.75 0 0 0 0-1.5H3ZM21 22.5a1.5 1.5 0 0 0 1.5-1.5v-5.25a.75.75 0 0 0-1.5 0V21h-5.25a.75.75 0 0 0 0 1.5H21ZM3 22.5A1.5 1.5 0 0 1 1.5 21v-5.25a.75.75 0 0 1 1.5 0V21h5.25a.75.75 0 0 1 0 1.5H3ZM22.5 3A1.5 1.5 0 0 0 21 1.5h-5.25a.75.75 0 0 0 0 1.5H21v5.25a.75.75 0 0 0 1.5 0V3Z"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFullscreen: this.__isFullscreen(),
    };
  },
  methods: {
    toggle() {
      if (this.isFullscreen) {
        this.$emit("exit-fullscreen");
        document.exitFullscreen();
      }
      else this.$emit("request-fullscreen");
    },
    __isFullscreen() {
      return document.fullscreenElement !== null;
    },
  },
  mounted() {
    document.addEventListener("fullscreenchange", () => {
      this.isFullscreen = this.__isFullscreen();
      if (!this.isFullscreen) this.$emit("exit-fullscreen");
    });
  },
};
</script>

<style scoped lang="scss">
@import "../jisti.scss";
</style>
